<template>
  <div class="footer">
    <ul class="footer_box">
      <li>
        <h3>关于远达</h3>
        <div class="footer_serve">
          <router-link tag="a" to="/brief-m" href class="item">关于远达</router-link>
          <router-link tag="a" to="/memory-m" href class="item">远达大事记</router-link>
          <router-link tag="a" to="/honour-m" href class="item">荣誉与认证</router-link>
          <router-link tag="a" to="/contact-m" href class="item">联系我们</router-link>
        </div>
      </li>
      <li>
        <h3>法律条款</h3>
        <div class="footer_serve">
          <a href class="item">服务条款</a>
          <a href class="item">隐私声明</a>
        </div>
      </li>
      <li>
        <h3>帮助中心</h3>
        <div class="footer_serve">
          <a href class="item">常见问题</a>
          <a href class="item">意见反馈</a>
        </div>
      </li>
      <li>
        <h3>关注我们</h3>

        <div class="weixin_img" @touchstart="showWeixin" ref="weixin_img" slot="reference">
          <img src="../assets/image_m/footer_weixin_notActive.png" alt v-show="isActive" />
          <img src="../assets/image_m/footer_weixin_Active.png" alt v-show="!isActive" />
          <div class="weixin_QR" v-show="!isActive">
            <img src="../assets/image_m/footer_QR.png" alt />
          </div>
        </div>
      </li>
      <li class="ICP">
        <a href="http://icp.chinaz.com/home/info?host=worldwideweb.org.cn" target="_blank">
          Copyright ©2015-2020 陕西远达智能科技有限公司
          <br />陕ICP备19005284号
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {
      isActive: true,
    };
  },
  watch: {},
  computed: {},
  methods: {
    showWeixin() {
      this.isActive = !this.isActive;
      if (this.isActive == false) {
        this.$refs.weixin_img.style.borderColor = "#08BF62";
      } else {
        this.$refs.weixin_img.style.borderColor = "#eaeaea";
      }
    },
  },
  created() {},
  mounted() {},
};
</script>
<style lang="less" scoped>
.footer {
  background: url("../assets/image_m/footer_bgc.png") no-repeat;
  background-position: center;
  background-size: 100% 90%;
  padding-bottom: 20px;
  padding-top: 20px;
  .footer_box {
    padding: 24px 16px 0 16px;

    li .weixin_img {
      position: relative;
      width: 30px;
      height: 30px;
      background: #ffffff;
      border: 1px solid #eaeaea;
      border-radius: 50%;
      text-align: center;
      line-height: 30px;
      .weixin_QR {
        position: absolute;
        width: 156px;
        height: 160px;
        bottom: 22px;
        left: -7px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      img {
        width: 18px;
        height: 15px;
      }
    }

    li h3 {
      margin: 4px 0 8px 0;
      line-height: 20px;
      font-size: 14px;
    }
    .footer_serve {
      .item {
        display: inline-block;
        width: 33%;
        margin-bottom: 8px;
        line-height: 17px;
        font-size: 12px;
      }
    }
  }
}
.ICP {
  font-size: 10px;
  line-height: 15px;
  color: #333333;
  opacity: 0.61;
  text-align: center;
  margin-top: 24px;
}
</style>